module.exports = __webpack_public_path__ + "img/39_72.6d1c3e93.png";